import styled from '@emotion/styled';
import { breakpoints } from '@naf/theme';

export const ChartContainer = styled.div`
  grid-column: 3 / -3;

  @media (max-width: ${breakpoints.m}) {
    grid-column: 1 / -1;
  }
`;
